import { useForm } from "react-hook-form";
// @mui
import { Stack, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import FormProvider, { RHFSwitch } from "../../../../../components/hook-form";
import {useLocales} from "../../../../../locales";

const DarkWebMonitoringForm = ({ user, scanStatus, onSubmitForm }) => {
  const defaultValues = {
    darkWebMonitoringEnabled: user?.darkWebMonitoringEnabled || false,
  };
  const { translate } = useLocales();
  const methods = useForm({
    defaultValues,
  });

  const {
    handleSubmit,
    reset,
    watch, // 🔥 Достаем функцию watch
    formState: { isSubmitting, isDirty },
  } = methods;

  const isToggleOn = watch("darkWebMonitoringEnabled");

  const onSubmit = async (data) => {
    await onSubmitForm(data);

    reset({
      darkWebMonitoringEnabled: data.darkWebMonitoringEnabled,
    });
  };

  const getButtonText = () => {
    if (isSubmitting) return translate("monitoringPage.btnUpdating");

    if (isDirty) {
      if (isToggleOn) return translate("monitoringPage.btnSaveAndScan");

      return translate("monitoringPage.btnSave")
    }

    if (scanStatus === "polling") return translate("monitoringPage.btnAddedToQueue")
    if (scanStatus === "completed") return translate("monitoringPage.btnDataRetrieved")

    return translate("monitoringPage.btnSave")
  };

  const isLoading = isSubmitting || (!isDirty && scanStatus === "polling");

  return (
    <FormProvider
      methods={methods}
      onSubmit={handleSubmit(onSubmit)}
      sx={{ marginBottom: "24px" }}
    >
      <Stack sx={{ mb: "24px" }}>
        <Typography
          variant="overline"
          component="div"
          sx={{ color: "text.secondary" }}
        >
          {translate("monitoringPage.title")}:
        </Typography>

        <Stack alignItems="flex-start" spacing={1} sx={{ mt: 2 }}>
          <RHFSwitch
            name="darkWebMonitoringEnabled"
            label={translate("monitoringPage.notifyToggleLabel")}
            sx={{ m: 0 }}
          />
        </Stack>

        <Typography
          variant="caption"
          component="div"
          sx={{ color: "text.secondary", mt: 0.5 }}
        >
          {translate("monitoringPage.consentDisclaimer")}
        </Typography>

        <LoadingButton
          type="submit"
          variant="contained"
          loading={isLoading}
          loadingPosition={isLoading ? "start" : undefined}
          startIcon={
            isLoading ? (
              <span style={{ display: "inline-block", width: "20px" }}></span>
            ) : null
          }
          disabled={!isDirty}
          sx={{
            alignSelf: "flex-start",
            mt: 3,
            color: "#ffffff",
            padding: "12px 18px",
            "& .MuiButton-startIcon": { marginRight: 1 },
          }}
        >
          {getButtonText()}
        </LoadingButton>
      </Stack>
    </FormProvider>
  );
};

export default DarkWebMonitoringForm;
